"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAssistantDayStatusApiResponseSchema = exports.setAssistantDayStatusApiPayloadSchema = void 0;
const zod_1 = require("zod");
const absence_enums_1 = require("./absence-enums");
exports.setAssistantDayStatusApiPayloadSchema = zod_1.z.object({
    status: absence_enums_1.assistantDayStatusSchema,
    reason: zod_1.z.string().trim().min(1).optional(),
});
/**
 * JSON:API envelope returned by PUT `/assistants/:id/days/:date/status`.
 * `updated` is the number of planned slots flipped — 0 on an empty rest day,
 * where only the absence record is written.
 */
exports.setAssistantDayStatusApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
        type: zod_1.z.literal('assistant-day-statuses'),
        attributes: zod_1.z.object({
            date: zod_1.z.string(),
            status: absence_enums_1.assistantDayStatusSchema,
            updated: zod_1.z.number(),
        }),
    }),
});
